const EXPLORE_BY_STAGE_EARLY = `${process.env.REACT_APP_ASSETS_BASE_URL}/home/image-explore-by-stage-early.webp`;
const EXPLORE_BY_STAGE_FUNDED = `${process.env.REACT_APP_ASSETS_BASE_URL}/home/image-explore-by-stage-funded.png`;
const EXPLORE_BY_STAGE_GROWTH = `${process.env.REACT_APP_ASSETS_BASE_URL}/home/image-explore-by-stage-growth.png`;

export const IMAGES_MAP = [
  EXPLORE_BY_STAGE_EARLY,
  EXPLORE_BY_STAGE_FUNDED,
  EXPLORE_BY_STAGE_GROWTH,
];

type TExploreByStage = {
  stage: string;
  descriptions: Array<{
    key: string;
    description: string;
  }>;
};

export const EXPLORE_BY_STAGE: TExploreByStage[] = [
  {
    stage: "Early",
    descriptions: [
      {
        key: "Technical Expertise:",
        description:
          "Access our seasoned developers specializing in SaaS product development.",
      },
      {
        key: "Faster Time to Market:",
        description:
          "Utilize our experience and best practices to expedite development cycles.",
      },
      {
        key: "Cost Efficiency:",
        description:
          "Benefit from flexible pricing models and avoid the overhead of an in-house team.",
      },
    ],
  },
  {
    stage: "Funded",
    descriptions: [
      {
        key: "Accelerated Development:",
        description:
          "Meet aggressive timelines and demonstrate progress with faster product launches.",
      },
      {
        key: "Access to Specialized Skills:",
        description:
          "Gain access to experienced developers with expertise in various technologies and industries.",
      },
      {
        key: "Scalability and Flexibility:",
        description:
          "Scale development efforts according to changing requirements without fixed commitments.",
      },
    ],
  },
  {
    stage: "Growth",
    descriptions: [
      {
        key: "Rapid Development and Iteration:",
        description:
          "Iterate quickly to meet growing user demands and market trends.",
      },
      {
        key: "Focus on Core Competencies:",
        description:
          "Delegate technical tasks to focus on scaling operations and maximizing revenue growth.",
      },
      {
        key: "Continuous Innovation and Differentiation:",
        description:
          "Stay ahead with continuous innovation and user-centric enhancements.",
      },
    ],
  },
];
